import storage from '@/utils/storage';
import { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";

// SCN05 

const ChangePasswordInformPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const props = location.state || null;

  useEffect(() => {
  }, [navigate, props]);

  // Handler for login button click
  const handleSubmit = () => {
    navigate('/login');
  }

  // Handler for clicking logo to go back to login and clear local storage
  const backToLogin = () => {
    storage.clearAll();
    navigate('/login');
  };

    // Render page UI
  return (
    <Fragment>
      <nav className="navbar navbar-expand-lg navbar-light justify-content-start bg-white p-0" >
        <ul className="navbar-nav ms-auto">
          <li className="nav-item d-flex justify-content-around" onClick={backToLogin} style={{ height: '71px' }}>
            <img className="m-1" src={logoCCBJI} alt="Logo 1" style={{ height: '90%' }} />
            <img className="m-1" src={logoFVJ} alt="Logo 1" style={{ height: '90%' }} />
          </li>
        </ul>
      </nav >
      <div className="container-fluid background-cover-external">

        <ol className="breadcrumb">
          <li className="breadcrumb-item active">パスワード変更完了</li>
        </ol>
        <div className="jumbotron">
          <div className="section">
            <div className="card-body" style={{ minHeight: '45vh' }}>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">
                  <p>
                    <span>パスワードの変更が完了しました。</span> <br />
                    <span>変更完了メールを送信しましたのでメールをご確認ください。</span>
                  </p>
                  <p>ログインは<button style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    color: 'inherit',
                    font: 'inherit',
                    cursor: 'pointer',
                    textDecoration: 'underline'
                  }} className="text-primary" onClick={handleSubmit}><u>コチラ</u></button>。</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChangePasswordInformPage;
